import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useMemo, useCallback, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import QueryParamProxy from '../../../utils/queryParamProxy';
import routeParamConstants from '../../../utils/routeParamConstants';
import screens from '../../';
import { useEffect } from 'react';
import Emitter from '../../../services/EmitterService';
import { EVENT_EMITTER_TYPE } from '../../../constants';
import { ACTION_COMMANDS_TYPE } from '../../../api/ActionCommandsInterface/constants';
import { useLazyGetPiggyBankQuery } from '../../../state/query/piggyBank';
import { PIGGY_BANK_EVENT_TYPES } from '../constants';
import { sendPiggyBankEvent } from '../analytics/piggyBankLogger';
import useNotification from '../../../hooks/useNotification';
import { getText, TEXT_KEY } from '../../../utils/localization';
var usePiggyBankUnlocked = function usePiggyBankUnlocked(props) {
  var dismissModal = props.dismissModal;
  var clickedButton = useRef(false);
  var _useNotification = useNotification(),
    addNotification = _useNotification.addNotification;
  var actionCommands = useSelector(function (state) {
    return state.actionCommands.actions.find(function (action) {
      var _action$payload;
      return (action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.screen) === screens.Home;
    }, shallowEqual);
  });
  var rawAssets = useSelector(function (state) {
    return state.assetsPackage.assets;
  }, shallowEqual);
  var piggyBankAssets = useMemo(function () {
    return (rawAssets === null || rawAssets === void 0 ? void 0 : rawAssets.PIGGY_BANK_FEATURE) || {};
  }, [rawAssets === null || rawAssets === void 0 ? void 0 : rawAssets.PIGGY_BANK_FEATURE]);
  var _useLazyGetPiggyBankQ = useLazyGetPiggyBankQuery(),
    _useLazyGetPiggyBankQ2 = _slicedToArray(_useLazyGetPiggyBankQ, 1),
    getPiggyBankUpdatedData = _useLazyGetPiggyBankQ2[0];
  var handlePiggyBankUnlocked = useCallback(function () {
    var _actionCommands$tutor;
    clickedButton.current = true;
    if (actionCommands !== null && actionCommands !== void 0 && (_actionCommands$tutor = actionCommands.tutorial) !== null && _actionCommands$tutor !== void 0 && (_actionCommands$tutor = _actionCommands$tutor.onCompleteAction) !== null && _actionCommands$tutor !== void 0 && _actionCommands$tutor.triggerExecution) {
      var _actionCommands$tutor2, _actionCommands$tutor3;
      sendPiggyBankEvent(PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_FINISH_TUTORIAL);
      Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
        actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
        data: {
          triggerExecution: actionCommands === null || actionCommands === void 0 || (_actionCommands$tutor2 = actionCommands.tutorial) === null || _actionCommands$tutor2 === void 0 || (_actionCommands$tutor2 = _actionCommands$tutor2.onCompleteAction) === null || _actionCommands$tutor2 === void 0 ? void 0 : _actionCommands$tutor2.triggerExecution,
          payload: actionCommands === null || actionCommands === void 0 || (_actionCommands$tutor3 = actionCommands.tutorial) === null || _actionCommands$tutor3 === void 0 || (_actionCommands$tutor3 = _actionCommands$tutor3.onCompleteAction) === null || _actionCommands$tutor3 === void 0 ? void 0 : _actionCommands$tutor3.payload,
          action: function action() {
            dismissModal();
            QueryParamProxy.setQueryParams(_defineProperty(_defineProperty({}, routeParamConstants.PARAM_MODAL, screens.PiggyBank), routeParamConstants.PARAM_PIGGY_BANK_TUTORIAL, true));
          }
        }
      });
    } else {
      addNotification({
        title: getText(TEXT_KEY.OOPS),
        message: getText(TEXT_KEY.DEFAULT_ERROR_MESSAGE),
        button: getText(TEXT_KEY.OK),
        hideCloseButton: true,
        hideHelpButton: true,
        buttonAction: function buttonAction() {
          dismissModal();
          QueryParamProxy.setQueryParams(_defineProperty(_defineProperty({}, routeParamConstants.PARAM_PIGGY_BANK_TUTORIAL, undefined), routeParamConstants.PARAM_PIGGY_BANK_PURCHASE_SUCCESS, undefined));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var handleCloseModal = useCallback(function () {
    var _actionCommands$tutor4, _actionCommands$tutor5;
    clickedButton.current = true;
    Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
      actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
      data: {
        triggerExecution: actionCommands === null || actionCommands === void 0 || (_actionCommands$tutor4 = actionCommands.tutorial) === null || _actionCommands$tutor4 === void 0 || (_actionCommands$tutor4 = _actionCommands$tutor4.onSkipAction) === null || _actionCommands$tutor4 === void 0 ? void 0 : _actionCommands$tutor4.triggerExecution,
        payload: actionCommands === null || actionCommands === void 0 || (_actionCommands$tutor5 = actionCommands.tutorial) === null || _actionCommands$tutor5 === void 0 || (_actionCommands$tutor5 = _actionCommands$tutor5.onSkipAction) === null || _actionCommands$tutor5 === void 0 ? void 0 : _actionCommands$tutor5.payload
      }
    });
    sendPiggyBankEvent(PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_SKIP_TUTORIAL);
    dismissModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    sendPiggyBankEvent(PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_DISPLAY_TUTORIAL);
    return function () {
      if (!clickedButton.current) {
        var _actionCommands$tutor6, _actionCommands$tutor7;
        Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
          actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
          data: {
            triggerExecution: actionCommands === null || actionCommands === void 0 || (_actionCommands$tutor6 = actionCommands.tutorial) === null || _actionCommands$tutor6 === void 0 || (_actionCommands$tutor6 = _actionCommands$tutor6.onSkipAction) === null || _actionCommands$tutor6 === void 0 ? void 0 : _actionCommands$tutor6.triggerExecution,
            payload: actionCommands === null || actionCommands === void 0 || (_actionCommands$tutor7 = actionCommands.tutorial) === null || _actionCommands$tutor7 === void 0 || (_actionCommands$tutor7 = _actionCommands$tutor7.onSkipAction) === null || _actionCommands$tutor7 === void 0 ? void 0 : _actionCommands$tutor7.payload
          }
        });
        sendPiggyBankEvent(PIGGY_BANK_EVENT_TYPES.PIGGY_BANK_SKIP_TUTORIAL);
      }
      Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
        actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND,
        data: {
          uuid: actionCommands === null || actionCommands === void 0 ? void 0 : actionCommands.uuid
        }
      });
      void getPiggyBankUpdatedData({}, {
        forceRefetch: true,
        refetchOnMountOrArgChange: true
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    piggyBankAssets: piggyBankAssets,
    dismissModal: dismissModal,
    handlePiggyBankUnlocked: handlePiggyBankUnlocked,
    handleCloseModal: handleCloseModal
  };
};
export default usePiggyBankUnlocked;